<ng-container *ngIf="filtersData?.filters">
    <ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="mediaService.deskmode()">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="mediaService.deskmode()">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-extra-wrapper-mobile">
        <div class="tmp-section-wrapper-mobile">
            <clever-selectionbtn [title]="'Veranstalter'" [list]="filtersData?.filters?.opi?.filterList"
                (sendRes)="setOpi($event)"></clever-selectionbtn>
            <clever-selectionbtn [title]="'Fahrzeugklasse'" [list]="filtersData?.filters?.fkl?.filterList"
                (sendRes)="setFkl($event)"></clever-selectionbtn>
        </div>
        <div class="tmp-section-wrapper-mobile">
            <clever-selectionbtn [title]="'Pakete'" [list]="filtersData?.filters?.pkt?.filterList"
                (sendRes)="setPkt($event)"></clever-selectionbtn>
            <clever-selectionbtn [title]="'Fahrzeugtyp'" [list]="filtersData?.filters?.fty?.filterList"
                (sendRes)="setFty($event)"></clever-selectionbtn>
        </div>
        <div class="tmp-section-wrapper-mobile">
            <clever-selectionbtn [title]="'Tankregelung'" [list]="filtersData?.filters?.trg?.filterList"
                (sendRes)="setTrg($event)"></clever-selectionbtn>
            <clever-mietzeit [mode]="'home'" [title]="'ab Zeit'" [isFrom]="true"></clever-mietzeit>
            <clever-mietzeit [mode]="'home'" [title]="'bis Zeit'" [isFrom]="false"></clever-mietzeit>
        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1" (click)="resetAll()" matRipple>
            <span>Alle Filter löschen</span>
        </button>
        <span></span>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-extra-wrapper">
        <div class="tmp-section-wrapper">
            <clever-selectionbtn [title]="'Veranstalter'" [list]="filtersData?.filters?.opi?.filterList"
                (sendRes)="setOpi($event)"></clever-selectionbtn>
            <clever-selectionbtn [title]="'Fahrzeugklasse'" [list]="filtersData?.filters?.fkl?.filterList"
                (sendRes)="setFkl($event)"></clever-selectionbtn>
            <!-- <clever-price [mode]="'home'"></clever-price> -->
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            <clever-selectionbtn [title]="'Pakete'" [list]="filtersData?.filters?.pkt?.filterList"
                (sendRes)="setPkt($event)"></clever-selectionbtn>
            <clever-selectionbtn [title]="'Fahrzeugtyp'" [list]="filtersData?.filters?.fty?.filterList"
                (sendRes)="setFty($event)"></clever-selectionbtn>
            <!-- <clever-direktflug [mode]="'home'"></clever-direktflug>
                <clever-travelclass [mode]="'home'"></clever-travelclass> -->
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            <clever-selectionbtn [title]="'Tankregelung'" [list]="filtersData?.filters?.trg?.filterList"
                (sendRes)="setTrg($event)"></clever-selectionbtn>
            <clever-mietzeit [mode]="'home'" [title]="'ab Zeit'" [isFrom]="true"></clever-mietzeit>
            <clever-mietzeit [mode]="'home'" [title]="'bis Zeit'" [isFrom]="false"></clever-mietzeit>
            <!-- <clever-flightzeit [mode]="'home'" [title]="'Hinflugzeit'" [isHinflug]="true"></clever-flightzeit>
            <clever-flightzeit [mode]="'home'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit> -->
        </div>
    </div>
    <div class="tmp-footer">
        <span></span>
        <div class="tmp-flexy">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span>Alle Filter löschen</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span>Schließen</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="nohome-wrapper-desk">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #nohomemodeMobile>
    <div class="nohome-wrapper">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #myfilters>
    <clever-selectionbtn [title]="'Veranstalter'" [list]="filtersData?.filters?.opi?.filterList"
        (sendRes)="setOpi($event)"></clever-selectionbtn>
    <clever-selectionbtn [title]="'Pakete'" [list]="filtersData?.filters?.pkt?.filterList" (sendRes)="setPkt($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Tankregelung'" [list]="filtersData?.filters?.trg?.filterList"
        (sendRes)="setTrg($event)"></clever-selectionbtn>
    <clever-selectionbtn [title]="'Fahrzeugtyp'" [isCheckBox]="true" [list]="filtersData?.filters?.fty?.filterList"
        (sendRes)="setFty($event)"></clever-selectionbtn>
    <clever-selectionbtn [title]="'Fahrzeugklasse'" [isCheckBox]="true" [list]="filtersData?.filters?.fkl?.filterList"
        (sendRes)="setFkl($event)"></clever-selectionbtn>
    <clever-selectionbtn [title]="'Inklusivleistungen'" [isCheckBox]="true" [list]="filtersData?.filters?.inc?.filterList"
        (sendRes)="setInc($event)"></clever-selectionbtn>
    <clever-selectionbtn [title]="'Versicherungen'" [isCheckBox]="true" [list]="filtersData?.filters?.ins?.filterList"
        (sendRes)="setIns($event)"></clever-selectionbtn>
    <clever-mietzeit [mode]="'home'" [title]="'ab Zeit'" [isFrom]="true"></clever-mietzeit>
    <clever-mietzeit [mode]="'home'" [title]="'bis Zeit'" [isFrom]="false"></clever-mietzeit>
</ng-template>

<ng-template #skloading>
    <div style="width: 100%;display: flex;flex-direction: column;margin-bottom: 1rem;">
        <div class="skeleton" style="height: 20px;width: 200px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 150px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 100px;margin-top: .5rem;"></div>
    </div>
</ng-template>